import { render, staticRenderFns } from "./Village.vue?vue&type=template&id=41945970&scoped=true&"
import script from "./Village.vue?vue&type=script&lang=js&"
export * from "./Village.vue?vue&type=script&lang=js&"
import style0 from "./Village.vue?vue&type=style&index=0&id=41945970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41945970",
  null
  
)

export default component.exports